export function FeaturesPage() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-4xl font-bold mb-4">Features</h1>
        <p className="text-gray-500">Feature details coming soon.</p>
      </div>
    </section>
  );
}
